export function groupBy(values, keyFinder) {
    // return Object.groupBy(values, keyFinder);
   return Object.groupBy ? Object.groupBy(values, keyFinder) : groupByShim(values, keyFinder);
}

function groupByShim(values, keyFinder) {
    console.log('USING SHIM');
    // using reduce to aggregate values
    return values.reduce((a, b) => {
        // depending upon the type of keyFinder
        // if it is function, pass the value to it
        // if it is a property, access the property
        const key = typeof keyFinder === 'function' ? keyFinder(b) : b[keyFinder];

        // aggregate values based on the keys
        if(!a[key]){
          a[key] = [b];
        }else{
          a[key] = [...a[key], b];
        }

        return a;
    }, {});
}
